<div class="home">

  <!-- ===================== HERO ===================== -->
  <section class="home-hero">
    <div class="home-hero__bg"
      [ngStyle]="cfg('HomeHeroBackgroundImage') ? { 'background-image': 'url(\'' + cfg('HomeHeroBackgroundImage') + '\')' } : {}">
    </div>
    <div class="home-hero__inner tw-container">
      <div class="home-hero__content">
        @if(cfg('HomeHeroUpperCaption')){
        <div class="home-hero__pill">
          <i class="pi pi-bolt"></i>
          <span>{{ cfg('HomeHeroUpperCaption') }}</span>
        </div>
        }
        <h1 class="home-hero__title">
          {{ cfg('HomeHeroMainCaption') }}
          <span class="home-hero__title--accent">{{ cfg('HomeHeroHighlightedCaption') }}</span>
        </h1>
        @if(cfg('HomeHeroLowerCaption')){
        <p class="home-hero__subtitle">{{ cfg('HomeHeroLowerCaption') }}</p>
        }

        <div class="home-hero__search">
          <span class="home-hero__search-icon"><i class="pi pi-map-marker"></i></span>
          <input type="text" [placeholder]="cfg('HomeHeroPostcodePlaceholder', 'Enter your postcode')"
            [(ngModel)]="postcode" (keyup.enter)="findFood()" />
          <button type="button" (click)="findFood()">{{ cfg('HomeHeroSearchButtonLabel', 'Find Food') }}</button>
        </div>
        <div class="home-hero__location-actions">
          @if(cfg('EnableDetectMyLocation') === 'true') {
          <button type="button" class="home-hero__detect" [disabled]="detectingPostcode"
            (click)="detectPostcodeFromMyLocation()">
            <i class="pi" [ngClass]="detectingPostcode ? 'pi-spin pi-spinner' : 'pi-crosshairs'"></i>
            {{ detectingPostcode ? 'Detecting...' : 'Use current post code' }}
          </button>
          }
          @if(locationMessage){
          <span class="home-hero__location-message" [class.home-hero__location-message--error]="locationMessage === 'Out of UK'">
            {{ locationMessage }}
          </span>
          }
        </div>

        <div class="home-hero__signup">
          <span class="home-hero__signup-text">{{ cfg('HomeHeroSignupCaption', 'New to Briteat? Join us today.') }}</span>
          <button type="button" class="home-hero__signup-btn" (click)="signup()">
            <i class="pi pi-user-plus"></i>
            {{ cfg('HomeHeroSignupLabel', 'Sign up') }}
          </button>
        </div>

        <div class="home-hero__benefits">
          @for(b of benefitBlocks; track b.title){
          <div class="home-hero__benefit">
            <span class="home-hero__benefit-icon">
              @if(b.image){<img [src]="b.image" [alt]="b.title" decoding="async" />} @else {<i class="pi" [ngClass]="b.icon"></i>}
            </span>
            <div>
              <div class="home-hero__benefit-title">{{ b.title }}</div>
              <div class="home-hero__benefit-caption">{{ b.caption }}</div>
            </div>
          </div>
          }
        </div>
      </div>

      <div class="home-hero__media">
        @if(heroPhotos.length){
        <div class="home-hero__slideshow" [class.home-hero__slideshow--single]="heroPhotos.length < 2">
          <div class="home-hero__slides" (pointerdown)="onHeroPointerDown($event)"
            (pointermove)="onHeroPointerMove($event)" (pointerup)="onHeroPointerUp()"
            (pointercancel)="onHeroPointerUp()" (mouseenter)="stopHeroAutoplay()"
            (mouseleave)="startHeroAutoplay()">
            <div class="home-hero__track" [class.home-hero__track--dragging]="heroDragging"
              [style.transform]="heroTrackTransform">
              @for(photo of heroPhotos; track $index; let i = $index){
              <div class="home-hero__slide">
                @if(i === 0){
                <!-- LCP image: eager, high priority, preloaded on the server -->
                <img class="home-hero__photo home-hero__photo--fill" [ngSrc]="photo" fill priority
                  sizes="(max-width: 640px) 100vw, 540px" [alt]="'Food ' + (i + 1)" draggable="false" />
                } @else if(isSlideLoaded(i)){
                <img class="home-hero__photo" [src]="photo" [alt]="'Food ' + (i + 1)" draggable="false"
                  loading="eager" fetchpriority="low" decoding="async" />
                }
              </div>
              }
            </div>
          </div>

          @if(heroPhotos.length > 1){
          <button type="button" class="home-hero__nav home-hero__nav--prev"
            (click)="goToHeroSlide(heroSlide - 1)" aria-label="Previous photo">
            <i class="pi pi-chevron-left"></i>
          </button>
          <button type="button" class="home-hero__nav home-hero__nav--next"
            (click)="goToHeroSlide(heroSlide + 1)" aria-label="Next photo">
            <i class="pi pi-chevron-right"></i>
          </button>
          <div class="home-hero__dots">
            @for(photo of heroPhotos; track $index; let i = $index){
            <button type="button" class="home-hero__dot" [class.home-hero__dot--active]="i === heroSlide"
              (click)="goToHeroSlide(i)" [attr.aria-label]="'Go to photo ' + (i + 1)"></button>
            }
          </div>
          }
        </div>
        }

        <div class="home-hero__delivery">
          <i class="pi pi-clock"></i>
          <div>
            <div class="home-hero__delivery-caption">{{ cfg('HomeHeroDeliveryBadgeCaption') }}</div>
            <div class="home-hero__delivery-time">{{ cfg('HomeHeroDeliveryBadgeTime') }}</div>
            @if(cfg('HomeHeroDeliveryBadgeSubCaption')){
            <div class="home-hero__delivery-sub"><i class="pi pi-map-marker"></i> {{ cfg('HomeHeroDeliveryBadgeSubCaption') }}</div>
            }
          </div>
        </div>

        @if(cfg('HomeHeroOfferCaption')){
        <div class="home-hero__offer">
          <div class="home-hero__offer-text">
            <div class="home-hero__offer-title">{{ cfg('HomeHeroOfferCaption') }}</div>
            <div class="home-hero__offer-sub">{{ cfg('HomeHeroOfferSubCaption') }}</div>
            @if(cfg('HomeHeroOfferCode')){
            <div class="home-hero__offer-code">Use code: <strong>{{ cfg('HomeHeroOfferCode') }}</strong></div>
            }
          </div>
          @if(cfg('HomeHeroOfferImage')){
          <img class="home-hero__offer-img" [src]="cfg('HomeHeroOfferImage')" alt="offer" decoding="async" />
          }
        </div>
        }
      </div>
    </div>
  </section>

  <div class="tw-container">

    <!-- ===================== POPULAR CATEGORIES ===================== -->
    @if(categories.length){
    <section class="home-section">
      <div class="home-section__head">
        <h2>{{ cfg('HomeCategoriesTitle', 'Popular Categories') }}</h2>
        @if(cfg('HomeCategoriesViewAllUrl')){
        <a class="home-section__link" (click)="navigate(cfg('HomeCategoriesViewAllUrl'))">
          {{ cfg('HomeCategoriesViewAllLabel', 'View all') }} <i class="pi pi-chevron-right"></i>
        </a>
        }
      </div>
      <div class="home-categories">
        @for(category of categories; track category.id){
        <button type="button" class="home-category" (click)="navigate(category.url)">
          <span class="home-category__img">
            @if(category.image){<img [src]="category.image" [alt]="category.title" loading="lazy" decoding="async" />}
            @else {<span class="home-category__placeholder">{{ initial(category.title) }}</span>}
          </span>
          <span class="home-category__title">{{ category.title }}</span>
        </button>
        }
      </div>
    </section>
    }

    <!-- ===================== POPULAR NEAR YOU ===================== -->
    <section class="home-section">
      <div class="home-section__head">
        <h2>{{ cfg('HomePopularNearYouTitle', 'Popular Near You') }}</h2>
        @if(cfg('HomePopularNearYouViewAllUrl')){
        <a class="home-section__link" (click)="navigate(cfg('HomePopularNearYouViewAllUrl'))">
          {{ cfg('HomePopularNearYouViewAllLabel', 'View all') }} <i class="pi pi-chevron-right"></i>
        </a>
        }
      </div>

      @if(loadingPopular){
      <div class="tw-flex tw-gap-4 tw-overflow-hidden">
        @for(i of [1,2,3,4]; track i){<div class="home-restaurant home-restaurant--skeleton"></div>}
      </div>
      } @else if(popular.length){
      <div class="home-restaurants">
        @for(business of popular; track business.Id){
        <a class="home-restaurant" [href]="businessUrl(business)" target="_blank">
          <div class="home-restaurant__banner tw-bg-cover"
            [ngStyle]="{ 'background-image': 'url(\'' + restaurantImage(business) + '\')' }">
            @if(etaLabel(business)){
            <span class="home-restaurant__eta">{{ etaLabel(business) }}</span>
            }
          </div>
          <div class="home-restaurant__info">
            @if(business?.UI?.Logo){
            <img class="home-restaurant__logo" [src]="business.UI.Logo" [alt]="business.UI?.Title" loading="lazy" decoding="async" />
            }
            <div class="home-restaurant__title-row">
              <h3>{{ business.UI?.Title || business.Name }}</h3>
              @if(ratingLabel(business)){
              <span class="home-restaurant__rating"><i class="pi pi-star-fill"></i>{{ ratingLabel(business) }}</span>
              }
            </div>
            <div class="home-restaurant__meta">{{ cuisineLabel(business) }}</div>
            <div class="home-restaurant__delivery">{{ deliveryLabel(business) }}</div>
          </div>
        </a>
        }
      </div>
      } @else {
      <p class="tw-text-center tw-opacity-60 tw-py-8">No restaurants to show yet.</p>
      }
    </section>

    <!-- ===================== FOOTER STORY TILES ===================== -->
    <section class="home-stories">
      @for(s of storyTiles; track s.title){
      <div class="home-story">
        <span class="home-story__icon">
          @if(s.image){<img [src]="s.image" [alt]="s.title" loading="lazy" decoding="async" />} @else {<i class="pi" [ngClass]="s.icon"></i>}
        </span>
        <div>
          <div class="home-story__title">{{ s.title }}</div>
          <div class="home-story__caption">{{ s.caption }}</div>
        </div>
      </div>
      }
    </section>

    <!-- ===================== APP BANNER ===================== -->
    <section class="home-app">
      @if(cfg('HomeAppBannerPhoneImage')){
      <img class="home-app__phone" [src]="cfg('HomeAppBannerPhoneImage')" alt="app" loading="lazy" decoding="async" />
      }
      <div class="home-app__text">
        <h2>{{ cfg('HomeAppBannerTitle', 'Get the Briteat app') }}</h2>
        <p>{{ cfg('HomeAppBannerCaption') }}</p>
      </div>
      <div class="home-app__badges">
        <a [href]="cfg('HomeAppBannerAppleUrl', '#')" target="_blank" class="home-app__badge">
          @if(cfg('HomeAppBannerAppleLogo')){<img [src]="cfg('HomeAppBannerAppleLogo')" alt="App Store" loading="lazy" decoding="async" />}
          @else {<i class="pi pi-apple"></i><span><small>Download on the</small>App Store</span>}
        </a>
        <a [href]="cfg('HomeAppBannerPlayStoreUrl', '#')" target="_blank" class="home-app__badge">
          @if(cfg('HomeAppBannerPlayStoreLogo')){<img [src]="cfg('HomeAppBannerPlayStoreLogo')" alt="Google Play" loading="lazy" decoding="async" />}
          @else {<i class="pi pi-google"></i><span><small>Get it on</small>Google Play</span>}
        </a>
      </div>
      @if(cfg('HomeAppBannerQrImage')){
      <a [href]="cfg('HomeAppBannerSmartUrl', '#')" target="_blank" class="home-app__qr">
        <img [src]="cfg('HomeAppBannerQrImage')" alt="QR" loading="lazy" decoding="async" />
      </a>
      }
    </section>

  </div>
</div>
